/* Moke America — location pages.
   Sticky header, smooth anchors, two-level Locations menu, mobile drawer.
   Mirrors the behaviour in the theme's moke-in-miami.js, scoped to .moke-page. */
(function () {
  "use strict";

  var DESKTOP = "(min-width: 981px)";
  var HOVER_OUT_DELAY = 180; // stops the panel flickering shut across gaps

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function isDesktop() {
    return window.matchMedia(DESKTOP).matches;
  }

  ready(function () {
    var page = document.querySelector(".moke-page");
    if (!page) return;

    /* ---------------- Sticky header state ---------------- */
    var header = document.querySelector("[data-moke-nav]");
    if (header) {
      var onScroll = function () {
        header.classList.toggle("moke-nav--scrolled", window.scrollY > 40);
      };
      onScroll();
      window.addEventListener("scroll", onScroll, { passive: true });
    }

    /* ---------------- Level 2: a state's cities ---------------- */

    function citiesOf(item) {
      return item.querySelector(".moke-loc__cities");
    }

    function setSub(item, open) {
      var list = citiesOf(item);
      var btn = item.querySelector(".moke-loc__expand");
      if (!list || !btn) return;

      btn.setAttribute("aria-expanded", String(open));
      list.hidden = !open;

      if (!open || !isDesktop()) {
        list.style.top = "";
        return;
      }

      // A flyout opens level with its own row, so one near the bottom of the
      // list (International) would hang off the screen. Flip horizontally if
      // it overruns the right edge, then lift it if it overruns the bottom.
      list.classList.remove("moke-loc__cities--flip");
      list.style.top = "";

      var doc = document.documentElement;
      var r = list.getBoundingClientRect();

      if (r.right > doc.clientWidth - 16) {
        list.classList.add("moke-loc__cities--flip");
        r = list.getBoundingClientRect();
      }

      if (r.bottom > doc.clientHeight - 16) {
        var menu = list.closest(".moke-locmenu");
        var ceiling = menu ? menu.getBoundingClientRect().top : 16;
        var wanted = Math.max(ceiling, doc.clientHeight - 16 - r.height);
        var base = parseFloat(getComputedStyle(list).top) || 0;
        list.style.top = base - (r.top - wanted) + "px";
      }
    }

    function closeAllSubs(scope) {
      (scope || page)
        .querySelectorAll(".moke-loc__item--has-sub")
        .forEach(function (i) { setSub(i, false); });
    }

    /* ---------------- Level 1: the Locations panel ---------------- */

    var locBtn = page.querySelector(".moke-menubtn");
    var locMenu = document.getElementById("moke-locmenu");
    var locWrap = locBtn && locBtn.closest(".moke-has-menu");
    var closeTimer;

    function setLoc(open) {
      if (!locBtn || !locMenu) return;
      locBtn.setAttribute("aria-expanded", String(open));
      locMenu.hidden = !open;
      if (!open) closeAllSubs(locMenu);
    }

    if (locBtn && locMenu) {
      locBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        setLoc(locBtn.getAttribute("aria-expanded") !== "true");
      });

      locWrap.addEventListener("mouseenter", function () {
        if (!isDesktop()) return;
        clearTimeout(closeTimer);
        setLoc(true);
      });

      locWrap.addEventListener("mouseleave", function () {
        if (!isDesktop()) return;
        closeTimer = setTimeout(function () { setLoc(false); }, HOVER_OUT_DELAY);
      });

      document.addEventListener("click", function (e) {
        if (locMenu.hidden) return;
        if (!locWrap.contains(e.target)) setLoc(false);
      });
    }

    /* ---------------- Wiring each state row ---------------- */

    page.querySelectorAll(".moke-loc__item--has-sub").forEach(function (item) {
      var btn = item.querySelector(".moke-loc__expand");
      var inDrawer = !!item.closest(".moke-drawer");

      // Click always toggles — this is the only way in on touch and keyboard.
      if (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          var open = btn.getAttribute("aria-expanded") !== "true";
          // In the flyout menu only one state may be open at a time.
          if (!inDrawer) closeAllSubs(item.parentNode);
          setSub(item, open);
        });
      }

      if (inDrawer) return; // the drawer stacks; no hover behaviour

      // Desktop: hovering (or tabbing into) a state reveals its cities.
      item.addEventListener("mouseenter", function () {
        if (!isDesktop()) return;
        closeAllSubs(item.parentNode);
        setSub(item, true);
      });
      item.addEventListener("mouseleave", function () {
        if (!isDesktop()) return;
        setSub(item, false);
      });
      item.addEventListener("focusin", function () {
        if (!isDesktop()) return;
        closeAllSubs(item.parentNode);
        setSub(item, true);
      });
    });

    /* ---------------- Mobile drawer ---------------- */

    var toggle = page.querySelector(".moke-navtoggle");
    var drawer = document.getElementById("moke-drawer");

    function setDrawer(open) {
      if (!toggle || !drawer) return;
      toggle.setAttribute("aria-expanded", String(open));
      drawer.hidden = !open;
      document.body.style.overflow = open ? "hidden" : "";
    }

    if (toggle && drawer) {
      toggle.addEventListener("click", function () {
        setDrawer(toggle.getAttribute("aria-expanded") !== "true");
      });
    }

    page.querySelectorAll(".moke-drawer__toggle").forEach(function (btn) {
      var panel = document.getElementById(btn.getAttribute("aria-controls"));
      if (!panel) return;
      btn.addEventListener("click", function () {
        var open = btn.getAttribute("aria-expanded") !== "true";
        btn.setAttribute("aria-expanded", String(open));
        panel.hidden = !open;
      });
    });

    /* ---------------- Shared dismissal ---------------- */

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      setLoc(false);
      setDrawer(false);
      if (locBtn) locBtn.blur();
    });

    // Crossing the breakpoint must not strand an open panel.
    var mq = window.matchMedia(DESKTOP);
    var onChange = function () {
      setLoc(false);
      setDrawer(false);
      closeAllSubs();
    };
    if (mq.addEventListener) mq.addEventListener("change", onChange);
    else if (mq.addListener) mq.addListener(onChange);

    /* ---------------- Smooth in-page anchors ---------------- */

    page.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener("click", function (event) {
        var id = anchor.getAttribute("href").slice(1);
        if (!id) return;
        var target = document.getElementById(id);
        if (!target) return;
        event.preventDefault();
        setDrawer(false);
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });

    /* Open the FAQ item a deep link points at */
    if (window.location.hash) {
      var details = document.querySelector(window.location.hash);
      if (details && details.tagName === "DETAILS") details.open = true;
    }
  });
})();

/* =========================================================================
   STORE LOCATOR
   Behaviour ported from the theme's store-locator.liquid, with three changes:

   1. Google Maps loads lazily, when the section nears the viewport, instead
      of on every page load. These are marketing pages; most visitors never
      scroll this far, and each load is a billable Maps call.
   2. The dealer list is rendered into the HTML at build time and only
      enhanced here, so it is crawlable and still works with JS off or if the
      Maps key is rejected.
   3. When nothing falls inside the chosen radius the original alerted and
      showed nothing. The page's own fine print promises "the search will
      still show the closest locations beyond that range", so it now sorts by
      distance and shows the nearest instead.
   ========================================================================= */
(function () {
  "use strict";

  var MI_PER_METRE = 1 / 1609.34;

  function haversineMiles(a, b) {
    var R = 3958.8, toRad = Math.PI / 180;
    var dLat = (b.lat - a.lat) * toRad, dLng = (b.lng - a.lng) * toRad;
    var la1 = a.lat * toRad, la2 = b.lat * toRad;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.sin(dLng / 2) * Math.sin(dLng / 2) * Math.cos(la1) * Math.cos(la2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }

  function init(root) {
    var dataEl = root.querySelector("[data-moke-dealers]");
    if (!dataEl) return;

    var config;
    try { config = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var dealers = config.dealers || [];
    var list = root.querySelector(".moke-locator__list");
    var status = root.querySelector(".moke-locator__status");
    var form = root.querySelector(".moke-locator__search");
    var input = root.querySelector('input[name="address"]');
    var select = root.querySelector('select[name="distance"]');

    var map = null, markers = {}, openInfo = null, mapsReady = false;

    function say(msg) {
      if (!status) return;
      status.textContent = msg || "";
      status.hidden = !msg;
    }

    function itemFor(id) {
      return list.querySelector('[data-dealer-id="' + id + '"]');
    }

    /* ---- show a given set of dealers, in a given order ---- */
    function show(ids, distances) {
      list.querySelectorAll(".moke-locator__item").forEach(function (li) {
        var id = li.getAttribute("data-dealer-id");
        var shown = ids.indexOf(id) !== -1;
        li.hidden = !shown;
        var d = li.querySelector(".moke-locator__dist");
        if (d) d.remove();
        if (shown && distances && distances[id] != null) {
          var span = document.createElement("span");
          span.className = "moke-locator__dist";
          span.textContent = distances[id].toFixed(1) + " mi";
          li.appendChild(span);
        }
        if (markers[id]) markers[id].setMap(shown && map ? map : null);
      });
      // reorder to match
      ids.forEach(function (id) {
        var li = itemFor(id);
        if (li) list.appendChild(li);
      });
    }

    function showAll() {
      show(dealers.map(function (d) { return String(d.id); }), null);
    }

    /* ---- Maps ---- */
    function buildMap() {
      var c = config.center || { lat: 27.9944, lng: -81.7603, zoom: 8 };
      map = new google.maps.Map(root.querySelector(".moke-locator__map"), {
        zoom: c.zoom || 8,
        center: { lat: c.lat, lng: c.lng },
        mapTypeControl: false,
        streetViewControl: false
      });
      root.classList.add("moke-locator--mapped");

      dealers.forEach(function (d) {
        var marker = new google.maps.Marker({
          position: { lat: d.lat, lng: d.lng }, map: map, title: d.name
        });
        var info = new google.maps.InfoWindow({
          content: '<strong>' + d.name + '</strong><br>' + d.address +
                   '<br>' + d.phone
        });
        marker.addListener("click", function () {
          if (openInfo) openInfo.close();
          openInfo = info; info.open(map, marker);
        });
        markers[String(d.id)] = marker;

        var li = itemFor(String(d.id));
        if (!li) return;
        li.addEventListener("mouseenter", function () {
          marker.setAnimation(google.maps.Animation.BOUNCE);
        });
        li.addEventListener("mouseleave", function () { marker.setAnimation(null); });
        li.addEventListener("click", function (e) {
          if (e.target.closest("a")) return;   // let "Get Directions" through
          map.setCenter(marker.getPosition());
          map.setZoom(12);
          if (openInfo) openInfo.close();
          openInfo = info; info.open(map, marker);
          list.querySelectorAll(".moke-locator__item")
              .forEach(function (x) { x.removeAttribute("aria-current"); });
          li.setAttribute("aria-current", "true");
        });
      });
      mapsReady = true;

      // The list was scoped on first paint, before a map existed to frame.
      // Re-apply now so the map opens on this page's dealers.
      showScope();
    }

    var loading = false;
    function loadMaps() {
      if (loading || mapsReady || !config.mapsApiKey) return;
      loading = true;
      window.mokeLocatorReady = function () { buildMap(); };
      var s = document.createElement("script");
      s.async = true;
      s.src = "https://maps.googleapis.com/maps/api/js?key=" +
              encodeURIComponent(config.mapsApiKey) +
              "&libraries=geometry&callback=mokeLocatorReady";
      s.onerror = function () { say("The map could not be loaded. All locations are listed above."); };
      document.head.appendChild(s);
    }

    /* ---- the page's own scope ----
       A city page opens on its own dealers, a state hub on all of them. The
       ranking is plain haversine, so this lands on first paint rather than
       waiting for Google Maps -- the visitor never sees the full alphabetical
       list flash past on a page whose headline says "Miami". */
    var originAttr = root.getAttribute("data-moke-origin");
    var pageOrigin = null;
    var pageRadius = parseFloat(root.getAttribute("data-moke-radius")) || 0;
    if (originAttr) {
      var parts = originAttr.split(",");
      var oLat = parseFloat(parts[0]);
      var oLng = parseFloat(parts[1]);
      if (isFinite(oLat) && isFinite(oLng)) pageOrigin = { lat: oLat, lng: oLng };
    }

    /* A state hub lists that state's dealers rather than ranking by distance
       from a point -- "near the middle of Arizona" is not what a visitor to
       the Arizona page is asking. Cities use the origin above instead. */
    var statesAttr = (root.getAttribute("data-moke-states") || "").trim();
    var pageStates = statesAttr
      ? statesAttr.toUpperCase().split(/[\s,]+/).filter(Boolean)
      : null;

    function showScope() {
      if (pageStates) {
        var ids = dealers
          .filter(function (d) { return pageStates.indexOf((d.state || "").toUpperCase()) !== -1; })
          .map(function (d) { return String(d.id); });
        show(ids.length ? ids : dealers.map(function (d) { return String(d.id); }), null);
        if (map && ids.length) {
          var b = new google.maps.LatLngBounds();
          dealers.forEach(function (d) {
            if (ids.indexOf(String(d.id)) !== -1) b.extend(new google.maps.LatLng(d.lat, d.lng));
          });
          map.fitBounds(b);
        }
        return true;
      }
      if (pageOrigin) { rank(pageOrigin, pageRadius); return true; }
      return false;
    }

    showScope();

    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { loadMaps(); io.disconnect(); }
        });
      }, { rootMargin: "400px" });
      io.observe(root);
    } else {
      loadMaps();
    }

    /* ---- search ---- */
    function rank(origin, limit) {
      var withDist = dealers.map(function (d) {
        return { id: String(d.id), miles: haversineMiles(origin, { lat: d.lat, lng: d.lng }) };
      }).sort(function (a, b) { return a.miles - b.miles; });

      var inRange = limit === 0 ? withDist
                                : withDist.filter(function (x) { return x.miles <= limit; });
      var fellBack = false;
      if (!inRange.length) { inRange = withDist.slice(0, 3); fellBack = true; }

      var distances = {};
      inRange.forEach(function (x) { distances[x.id] = x.miles; });
      show(inRange.map(function (x) { return x.id; }), distances);

      say(fellBack
        ? "No locations within " + limit + " mi. Showing the closest instead."
        : "");

      if (map) {
        var bounds = new google.maps.LatLngBounds();
        bounds.extend(new google.maps.LatLng(origin.lat, origin.lng));
        inRange.forEach(function (x) {
          var d = dealers.filter(function (y) { return String(y.id) === x.id; })[0];
          bounds.extend(new google.maps.LatLng(d.lat, d.lng));
        });
        map.fitBounds(bounds);
      }
    }

    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var address = (input.value || "").trim();
        var limit = parseInt(select.value, 10) || 0;

        if (!address) { say("Enter a city or state to search."); input.focus(); return; }
        if (!mapsReady) {
          // A single 800ms retry swallowed the first search whenever Maps was
          // slower than that. Poll until it is ready, then run the search the
          // visitor already asked for.
          loadMaps();
          say("Loading the map…");
          var waited = 0;
          var poll = window.setInterval(function () {
            waited += 200;
            if (mapsReady) {
              window.clearInterval(poll);
              if (form.requestSubmit) form.requestSubmit();
              else form.dispatchEvent(new Event("submit", { cancelable: true }));
            } else if (waited >= 8000) {
              window.clearInterval(poll);
              say("The map could not load. Every location is listed below.");
            }
          }, 200);
          return;
        }

        say("");
        new google.maps.Geocoder().geocode({ address: address }, function (results, s) {
          if (s !== "OK" || !results.length) {
            say("We could not find that place. Try a city or state.");
            return;
          }
          var loc = results[0].geometry.location;
          rank({ lat: loc.lat(), lng: loc.lng() }, limit);
        });
      });

      form.addEventListener("reset", function () {
        if (!showScope()) showAll();
        say("");
      });
    }
  }

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }
  ready(function () {
    document.querySelectorAll("[data-moke-locator]").forEach(init);
  });
})();
